import BaseViz from './BaseViz'
import BarChartChart from '../charts/BarChartChart'
import BarChartDataController from '../viz_behaviors/BarChartDataController'
export default class BarChartViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical', 'single'],
      },
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
          exposed: false,
        },
        valueFormat: {
          nonEditable: true,
          exposed: false,
        },
        unit: {
          nonEditable: true,
          exposed: false,
        },
        scale: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
      },
    },
    LegendBehavior: {
      showLegend: {
        value: false,
      },
    },
  }
  static chartClass = BarChartChart
  static dataControllerClass = BarChartDataController
}
